import {RestResource} from '../rest'

import {ORGANIZATION_SERVER} from '../server'

const positionGradeRole = new RestResource({server: ORGANIZATION_SERVER, resource: 'positionGradeRole'});

export default positionGradeRole;